import styled from 'styled-components'

export const Columns = styled.div`
  display: flex;
  width: 680px;
  gap: 30px;
`

export const Column = styled.div`
  flex: 1;
`
